'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { createQueryString } from '@/lib/functions/createQueryString';
import StylizedSelect from '@/components/stylizedSelect';

type SearchCategorySortingProps = {
  defaultValues: {
    show: number;
    orderby: string;
  };
  orderBy?: string;
  pageSize?: number;
  styles: any;
};

const SearchCategorySorting: React.FC<SearchCategorySortingProps> = ({
  defaultValues,
  orderBy,
  pageSize,
  styles,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleShowChange = (option: string | number) => {
    router.push(
      pathname +
        '?' +
        createQueryString('pageSize', option.toString(), searchParams.toString())
    );
  };

  const handleSortChange = (option: any) => {
    router.push(
      pathname +
        '?' +
        createQueryString('orderBy', option, searchParams.toString())
    );
  };

  const showOptions = [
    { value: 8, label: '8 Results' },
    { value: 16, label: '16 Results' },
    { value: 32, label: '32 Results' },
    { value: 48, label: '48 Results' },
    { value: 64, label: '64 Results' },
    { value: 80, label: '80 Results' },
    { value: 96, label: '96 Results' },
  ];

  const sortOptions = [
    { value: 'relevance', label: 'Sort by relevance' },
    { value: 'price_asc', label: 'Sort by price: low to high' },
    { value: 'price_desc', label: 'Sort by price: high to low' },
  ];

  return (
    <form className={styles?.form}>
      <StylizedSelect
        label="Show"
        name="show"
        placeHolder="16 Results"
        options={showOptions}
        onChange={handleShowChange}
        styles={styles}
        defaultValue={pageSize ?? defaultValues.show}
      />
      <StylizedSelect
        label="Sort By"
        name="orderby"
        placeHolder="Sort by relevance"
        options={sortOptions}
        onChange={handleSortChange}
        styles={styles}
        defaultValue={orderBy ?? defaultValues.orderby}
      />
    </form>
  );
};

export default SearchCategorySorting;
